import {
  FORECAST_NUMBER_OF_DAYS_FOR_REGIONAL_ONLY_USERS,
  HISTORICAL_NUMBER_OF_DAYS_FOR_REGIONAL_ONLY_USERS,
} from '@semios/app-platform-values-helpers-and-types'
import moment from 'moment-timezone'
import { SharedSettings } from 'settings/SharedSettings'
import { constructDateWithTimeZone } from './constructDateWithTimeZone'

const DEFAULT_FORECAST_DAYS = 14

const getForecastDays = (args: { isHistoricalOnly?: boolean; isSelfRegisteredUser?: boolean }) => {
  if (args.isSelfRegisteredUser) return FORECAST_NUMBER_OF_DAYS_FOR_REGIONAL_ONLY_USERS

  return args.isHistoricalOnly ? 0 : DEFAULT_FORECAST_DAYS
}

export const getDateRangeLimits = (args: {
  isHistoricalOnly?: boolean
  isSelfRegisteredUser?: boolean
  maxDate?: moment.Moment
  minDate?: moment.Moment
  timezone: string
}) => {
  const { isSelfRegisteredUser, timezone } = args
  const forecastDays = getForecastDays(args)
  const furthestForecast = moment.tz(timezone).add(forecastDays, 'days')

  const getMaxDate = () => {
    if (!isSelfRegisteredUser) return args.maxDate ?? furthestForecast

    // Regional-only users see no forecast unless a max date allows it, and never past the forecast limit
    if (!args.maxDate) return moment.tz(timezone)

    return args.maxDate.isValid() && args.maxDate.isBefore(furthestForecast) ? args.maxDate : furthestForecast
  }

  const earliest = isSelfRegisteredUser
    ? moment.tz(timezone).subtract(HISTORICAL_NUMBER_OF_DAYS_FOR_REGIONAL_ONLY_USERS, 'days')
    : moment.tz(SharedSettings.FIRST_DAY_OF_DATA_FOR_MANY_THINGS, timezone)

  return {
    forecastDays,
    maxDate: constructDateWithTimeZone(getMaxDate().toString(), timezone),
    minDate: constructDateWithTimeZone((args.minDate ?? earliest).toString(), timezone),
    presetEndDate: constructDateWithTimeZone(furthestForecast.clone().endOf('day').toString(), timezone),
  }
}
